<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'wallet-list',
  props: {
    wallet: {
      type: Object
    }
  },
  data() {
    return {

    }
  }
}
</script>

<style>

</style>
